import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { CrossingTrackDelay } from '@/types/crossing-track-delay'

export function getCrossingTrackDelays(
  date: string,
  stopShort: string
): Promise<AxiosResponse<CrossingTrackDelay[]>> {
  return instance.get<CrossingTrackDelay[]>(
    `/crossing-track-delay?date=${date}&stopShort=${stopShort}`
  )
}
